/**
 * @file 保存通知
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface ISetTopOutput {
    status: number;
}

export interface ISetTopInput {
    feed_id: number; // int，动态编号
    is_top: 0 | 1; // int，0：取消置顶；1：置顶
}

export const setTopFeed = (data: ISetTopInput): Promise<IResponse<ISetTopOutput>> => {
    return fetchData(Api.CLASS_SET_TOP_FEED, data).then((res: IResponse<ISetTopOutput>) => {
        return res.data as ISetTopOutput;
    });
};
